<template>
  <div>
    <headers />

    <!-- <div class="breadcrumb" :key="itemKey">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ "考试中心" }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <div class="content">
      <div class="contentBox">
        <div class="contentBoxTitle">{{ infoData.name }}</div>
        <div class="contentBoxContent">
          <div class="contentHeader">
            <div class="left">
              <span>答题进度</span>
              <span class="leftProgress">{{ index + 1 }}</span>
              <span class="leftNoProgress">/{{ listData.length }}</span>
            </div>

            <div class="right" v-if="!situationId">
              <img src="../../assets/images/timeIcon.png" alt="" />
              <span class="rightText">剩余时间</span>
              <span class="rightTime">{{ formattedTime }}</span>
            </div>
          </div>
        </div>
        <!-- jindutiao -->
        <div class="line">
          <div :style="{ width: progressWidth + '%' }"></div>
        </div>
      </div>
      <!-- timu -->

      <div class="contentList" v-if="listData.length">
        <div class="contentListTitle">
          {{ index + 1 + ". " }}{{ listData[index].title }}
        </div>
        <div class="contentListType">
          {{ listData[index].type == 1 ? "单选题" : (listData[index].type == 3 ? "判断题" : "多选题") }}
        </div>

        <div class="contentListBox">
          <div
            class="contentListBoxItem"
            v-for="(item, childIndex) in listData[index].children"
            :key="childIndex"
            @click="!situationId && handleSelect(item)"
            :class="listData[index].answered ? item.statusClass : ''"
            :style="{ cursor: (situationId || listData[index].answered) ? 'default' : 'pointer' }"
          >
            <div
              :class="[listData[index].answered ? item.checkClass : (item.checked ? 'active' : ''), 'contentListBoxItemCheck']"
            >
              <!-- 学员亲自勾选且答对：实心绿色对勾 -->
              <i
                v-if="listData[index].answered && item.checked && item.isAnswer"
                class="el-icon-check check-icon green-check"
              ></i>
              <!-- 学员勾选但答错：红色打叉 -->
              <i
                v-else-if="listData[index].answered && item.checked && !item.isAnswer"
                class="el-icon-close check-icon red-cross"
              ></i>
              <!-- 正确答案但学员未勾选(漏选)：虚线/浅色绿色对勾提示 -->
              <i
                v-else-if="listData[index].answered && !item.checked && item.isAnswer"
                class="el-icon-check check-icon miss-green-check"
              ></i>
              <!-- 答题确认前的普通选中状态图标 -->
              <img
                v-else-if="item.checked"
                src="../../assets/images/checked.png"
                alt=""
              />
            </div>
            <div
              :class="[listData[index].answered ? item.textClass : (item.checked ? 'active' : ''), 'contentListBoxItemText']"
            >
              {{ item.key + ". " }}{{ item.content }}
            </div>
          </div>
        </div>

        <!-- 答题即时反馈提示栏 -->
        <div
          v-if="!situationId && listData[index].answered"
          class="instant-feedback-bar"
          :class="listData[index].isCorrect ? 'feedback-correct' : 'feedback-wrong'"
        >
          <template v-if="listData[index].isCorrect">
            <i class="el-icon-circle-check feedback-status-icon"></i>
            <span class="feedback-msg-text">回答正确</span>
          </template>
          <template v-else>
            <i class="el-icon-circle-close feedback-status-icon"></i>
            <span class="feedback-msg-text">
              回答错误，正确答案为：<strong class="highlight-ans">{{ getFormattedCorrectAnswer(listData[index]) }}</strong>
            </span>
          </template>
        </div>

        <div
          v-if="situationId && listData[index]"
          class="instant-feedback-bar"
          :class="listData[index].isCorrect ? 'feedback-correct' : 'feedback-wrong'"
        >
          <template v-if="listData[index].isCorrect">
            <i class="el-icon-circle-check feedback-status-icon"></i>
            <span class="feedback-msg-text">
              回答正确！您的选择：<strong class="highlight-ans">{{ listData[index].userAnswerStr }}</strong>，正确答案：<strong class="highlight-ans">{{ listData[index].realAnswerStr }}</strong>
            </span>
          </template>
          <template v-else>
            <i class="el-icon-circle-close feedback-status-icon"></i>
            <span class="feedback-msg-text">
              回答错误。您的选择：<strong class="highlight-ans font-red">{{ listData[index].userAnswerStr }}</strong>，正确答案：<strong class="highlight-ans font-green">{{ listData[index].realAnswerStr }}</strong>
            </span>
          </template>
        </div>

        <div class="contentListFooter">
          <div class="pre" v-if="index !== 0" @click="handlePrev">上一题</div>
          <div
            v-if="!situationId"
            class="next"
            :style="{ width: index === 0 ? '300px' : '200px' }"
            @click="handleNext"
          >
            {{ getNextBtnText }}
          </div>
          <div
            v-else
            class="next"
            :style="{ width: index === 0 ? '300px' : '200px' }"
            @click="handleNextView"
          >
            下一题
          </div>
        </div>
      </div>
    </div>

    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import search from "@/components/search.vue";

import { examQuestion, examCommit, examSituation } from "@/api/examination";
export default {
  name: "news",
  components: {
    headers,
    footers,
    search,
  },
  data() {
    return {
      index: 0,
      listData: [],
      itemKey: Math.random(),
      endTime: 0,
      targetEndTime: 0, // 考试截止目标绝对时间戳（毫秒）
      timer: null,
      formattedTime: "00:00:00",
      id: "",
      startTime: 0,
      progressWidth: 0,
      disabled: false,
      infoData: {},
      situationId: "", // 查看答题情况id
      situationIndex: "", // 当前查看第几题
      taskId: "", // 学习任务ID
      isCode431: false, // 标记是否属于 431 异常（暂无可用试题），为 true 时禁止自动提交试卷
      isSubmitted: false, // 标记是否已完成正常交卷
    };
  },
  beforeRouteLeave(to, from, next) {
    // 离开页面时清除倒计时定时器
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    // 若属于 431 状态、查看模式、已提交或无可用试卷数据，直接放行，禁止触发任何交卷提交
    if (this.isCode431 || this.situationId || !this.id || !this.listData.length || this.isSubmitted) {
      next();
      return;
    }
    next();
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeDestroy() {
    // 组件销毁前清除定时器及可见性监听
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  },
  created() {
    // 获取路由参数，如果有传入学习任务ID或试卷ID等信息在此处获取
    this.taskId = this.$route.query.taskId || this.$route.query.id || "";
    this.situationId = this.$route.query.situationId || "";
    this.situationIndex = this.$route.query.situationIndex || "";
    this.situationId && this.getSituation();
    !this.situationId && this.examQuestion();
  },
  computed: {
    /**
     * 获取底部主按钮的动态显示文案
     * 未校验结果前显示“确认”，已校验出正确/错误结果后显示“下一题”或“交卷”
     * @returns {string} 按钮显示的文本内容
     */
    getNextBtnText() {
      if (!this.listData || !this.listData.length) return "确认";
      const currentQuestion = this.listData[this.index];
      if (!currentQuestion) return "确认";
      if (!currentQuestion.answered) {
        return "确认";
      }
      return this.index === this.listData.length - 1 ? "交卷" : "下一题";
    },
  },
  mounted() {
    // 监听标签页激活/可见性切换，切换回页面时秒级校准倒计时
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  methods: {
    /**
     * 格式化秒数为 mm:ss
     * @param {number} seconds - 总秒数
     * @returns {string} 格式化后的时间字符串
     */
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return `${minutes.toString().padStart(2, "0")}:${secs
        .toString()
        .padStart(2, "0")}`;
    },

    /**
     * 刷新并校准考试倒计时
     * 基于目标截止绝对时间戳 (targetEndTime) 与当前真实时间戳计算剩余时长，
     * 解决浏览器切换标签页或最小化时后台节流导致倒计时停顿/滞后的问题
     * @returns {void}
     */
    tickCountdown() {
      if (!this.targetEndTime) return;

      const now = Date.now();
      const remainingMs = this.targetEndTime - now;
      const remainingSeconds = Math.max(0, Math.ceil(remainingMs / 1000));

      this.endTime = remainingSeconds;
      this.formattedTime = this.formatTime(this.endTime);

      // 倒计时结束，触发自动交卷（非 431 且存在试卷题目时生效）
      if (remainingSeconds <= 0) {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        if (!this.isCode431 && this.id && this.listData.length) {
          this.handleSubmit(false);
        }
      }
    },

    /**
     * 开始考试倒计时
     * @param {number} [durationSeconds] - 考试总时长（单位：秒）
     * @returns {void}
     */
    startCountdown(durationSeconds) {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      const totalSeconds = durationSeconds !== undefined ? durationSeconds : this.endTime;
      // 记录考试截止的目标绝对时间戳
      this.targetEndTime = Date.now() + totalSeconds * 1000;

      // 立即刷新校准一次展示时间
      this.tickCountdown();

      this.timer = setInterval(() => {
        this.tickCountdown();
      }, 1000);
    },

    /**
     * 页面可见性改变事件监听处理函数 (Page Visibility API)
     * 当用户从其他标签页切回当前页面时，立即主动触发一次时间校准
     * @returns {void}
     */
    handleVisibilityChange() {
      if (document.visibilityState === "visible" && !this.situationId && this.targetEndTime) {
        this.tickCountdown();
      }
    },

    /**
     * 更新考试进度条宽度 (使用 CSS 硬件加速过渡)
     * @returns {void}
     */
    updateProgress() {
      if (!this.listData || !this.listData.length) return;
      this.progressWidth = ((this.index + 1) / this.listData.length) * 100;
    },

    /**
     * 离开当前考试页面并安全返回上一页
     * @returns {void}
     */
    leaveExamPage() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push("/school/index");
      }
    },

    /**
     * 获取考试题目数据
     * 若接口返回 431（代表学习任务关联课程暂无可用题目，暂不允许考试），
     * 弹出错误提示并在短暂延迟后自动返回离开页面，且严格禁止执行任何交卷提交逻辑。
     * @returns {Promise<void>}
     */
    async examQuestion() {
      try {
        const taskId =
          this.taskId || this.$route.query.taskId || this.$route.query.id || "";
        const res = await examQuestion({ taskId });
        if (res && (res.code == 200 || res.code == 0 || res.success)) {
          this.infoData = res.data;
          if (res.data && res.data.details) {
            res.data.details.map((item) => {
              item.children = Object.entries(item.titleOptionJson || {}).map(
                ([k, v]) => ({
                  key: k,
                  content: v,
                  checked: false,
                  isAnswer: false,
                  statusClass: "",
                  checkClass: "",
                  textClass: "",
                })
              );
              this.$set(item, "answered", false); // 标记是否已完成即时回答校验
              this.$set(item, "isCorrect", false); // 标记学员回答是否正确
              this.$set(item, "userAnswerStr", ""); // 记录学员勾选的选项 Key 字符串
            });
            this.id = res.data.id;
            this.listData = res.data.details;
          }

          // 只有在非查看模式下才启动倒计时
          if (!this.situationId) {
            this.endTime = res.data.examTime * 60;
            this.formattedTime = this.formatTime(this.endTime);
            this.startTime = Date.now();
            this.startCountdown(this.endTime);
          }

          this.updateProgress();
        } else if (res && res.code == 431) {
          // 标记为 431 状态，清除定时器，弹出提示后离开页面，禁止触发交卷
          this.isCode431 = true;
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
          const msg = (res && (res.msg || res.message)) || "学习任务关联课程暂无可用题目，暂不允许考试";
          this.$message.warning(msg);
          setTimeout(() => {
            this.leaveExamPage();
          }, 1500);
        }
      } catch (error) {
        console.error("获取考试题目失败:", error);
        const is431 =
          error &&
          (error.code == 431 ||
            (error.response && error.response.status == 431) ||
            (error.response && error.response.data && error.response.data.code == 431));
        if (is431) {
          // 标记为 431 状态，清除定时器，弹出提示后离开页面，禁止触发交卷
          this.isCode431 = true;
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
          const msg =
            (error.response && error.response.data && (error.response.data.msg || error.response.data.message)) ||
            error.msg ||
            error.message ||
            "学习任务关联课程暂无可用题目，暂不允许考试";
          this.$message.warning(msg);
          setTimeout(() => {
            this.leaveExamPage();
          }, 1500);
        }
      }
    },

    /**
     * 跳转至考试分数/结果页面
     * 当接口返回 431（考试状态有误）或正常交卷时跳转至结果页，由结果页自动补全拉取成绩及通过状态
     * @param {Object} [extraData={}] - 接口返回的得分、用时等额外数据（可选）
     * @returns {void}
     */
    navigateToResult(extraData = {}) {
      const examId = this.id || this.$route.query.id || "";
      const taskId = this.taskId || this.$route.query.taskId || "";
      this.$router.replace({
        name: "examinationResult",
        query: {
          id: examId,
          taskId: taskId,
          ...(extraData || {}),
        },
      });
    },

    /**
     * 校验当前题目学员解答的正确性，预先高效计算各选项的 CSS Class 状态
     * @param {Object} question - 当前题目数据对象
     * @returns {void}
     */
    checkCurrentQuestionAnswer(question) {
      if (!question || question.answered) return;

      // 提取学员所选选项 Key（字母升序排列）
      const selectedKeys = (question.children || [])
        .filter((child) => child.checked)
        .map((child) => child.key)
        .sort();

      const userAnswerStr = selectedKeys.join("").toUpperCase();
      
      // 标准化正确答案格式（兼容 answer 与 realAnswer 字段，去除标点/空格后排序）
      const rawAnswer = question.answer || question.realAnswer || "";
      const correctAnswerStr = rawAnswer
        .replace(/[,，\s]/g, "")
        .split("")
        .sort()
        .join("")
        .toUpperCase();

      const cleanAnswer = correctAnswerStr;
      const isCorrect = userAnswerStr.length > 0 && userAnswerStr === correctAnswerStr;

      // 预先给每个选项子项绑定算好的 Class 字符串，大幅减轻 Vue 渲染层负担
      (question.children || []).forEach((child) => {
        const isAns = cleanAnswer.includes(child.key.toUpperCase());
        this.$set(child, "isAnswer", isAns);
        if (child.checked) {
          this.$set(child, "statusClass", isAns ? "is-correct-target" : "is-wrong-target");
          this.$set(child, "checkClass", isAns ? "correct-check-box" : "wrong-check-box");
          this.$set(child, "textClass", isAns ? "correct-text" : "wrong-text");
        } else {
          this.$set(child, "statusClass", isAns ? "is-miss-target" : "");
          this.$set(child, "checkClass", isAns ? "miss-check-box" : "");
          this.$set(child, "textClass", isAns ? "miss-text" : "");
        }
      });

      // 使用 Vue2 $set 确保视图即时响应更新
      this.$set(question, "userAnswerStr", userAnswerStr);
      this.$set(question, "isCorrect", isCorrect);
      this.$set(question, "answered", true);
    },

    /**
     * 多选题点击“确认答案”按钮显式触发校验
     * @param {Object} question - 当前多选题数据对象
     * @returns {void}
     */
    confirmMultiAnswer(question) {
      if (!question) return;
      const hasSelected = (question.children || []).some((child) => child.checked);
      if (!hasSelected) {
        this.$message.warning("请至少选择一个选项");
        return;
      }
      this.checkCurrentQuestionAnswer(question);
    },

    /**
     * 判断某个选项 Key 是否属于正确答案之一
     * @param {string} key - 选项 key
     * @param {Object|string} questionOrAnswer - 题目数据对象或标准答案字符串
     * @returns {boolean} 为 true 表示当前 key 是正确答案之一
     */
    isKeyInAnswer(key, questionOrAnswer) {
      if (!key) return false;
      let rawAnswer = "";
      if (typeof questionOrAnswer === "object" && questionOrAnswer !== null) {
        rawAnswer = questionOrAnswer.answer || questionOrAnswer.realAnswer || "";
      } else if (typeof questionOrAnswer === "string") {
        rawAnswer = questionOrAnswer;
      }
      if (!rawAnswer) return false;
      const cleanAnswer = rawAnswer.replace(/[,，\s]/g, "").toUpperCase();
      return cleanAnswer.includes(key.toUpperCase());
    },

    /**
     * 计算当前选项外框容器的动态样式 Class
     * @param {Object} item - 当前选项数据对象
     * @param {Object} question - 当前题目数据对象
     * @returns {Object} 绑定的 class 对象
     */
    getOptionItemClass(item, question) {
      if (!question || !question.answered) return {};
      const isAnswer = this.isKeyInAnswer(item.key, question);
      if (item.checked) {
        return isAnswer ? { "is-correct-target": true } : { "is-wrong-target": true };
      } else {
        return isAnswer ? { "is-miss-target": true } : {};
      }
    },

    /**
     * 计算选项渲染勾选框背景及图标样式 Class
     * @param {Object} item - 当前选项对象
     * @param {Object} question - 当前题目对象
     * @returns {string}
     */
    getOptionCheckClass(item, question) {
      if (question && question.answered) {
        const isAnswer = this.isKeyInAnswer(item.key, question);
        if (item.checked) {
          return isAnswer ? "correct-check-box" : "wrong-check-box";
        } else {
          return isAnswer ? "miss-check-box" : "";
        }
      }
      return item && item.checked ? "active" : "";
    },

    /**
     * 计算选项文本颜色样式 Class
     * @param {Object} item - 当前选项对象
     * @param {Object} question - 当前题目对象
     * @returns {string}
     */
    getOptionTextClass(item, question) {
      if (question && question.answered) {
        const isAnswer = this.isKeyInAnswer(item.key, question);
        if (item.checked) {
          return isAnswer ? "correct-text" : "wrong-text";
        } else {
          return isAnswer ? "miss-text" : "";
        }
      }
      return item && item.checked ? "active" : "";
    },

    /**
     * 获取题目格式化后的标准正确答案展示文本
     * @param {Object} question - 当前题目数据对象
     * @returns {string} 格式化后的正确答案，如 "A、B"
     */
    getFormattedCorrectAnswer(question) {
      if (!question) return "无";
      const raw = (question.answer || question.realAnswer || "").replace(/[,，\s]/g, "");
      if (!raw) return "无";
      return raw.split("").join("、");
    },

    /**
     * 用户点击选择选项处理函数
     * 支持单选题 (type=1) / 判断题 (type=3) 的排他单选，以及多选题 (type=2) 的复选逻辑
     * 使用 this.$set 与 this.$forceUpdate 强制 Vue 瞬间响应重绘，消除回显延迟
     * @param {Object} item - 当前点击选择的选项数据对象
     * @returns {void}
     */
    handleSelect(item) {
      const currentQuestion = this.listData[this.index];
      // 如果当前题目已提交确认并展示即时反馈，则锁定选项禁止修改
      if (!currentQuestion || currentQuestion.answered) return;

      if (currentQuestion.type === 1 || currentQuestion.type === 3) {
        // 单选题与判断题逻辑：选定当前项，取消其他项
        currentQuestion.children.forEach((child) => {
          this.$set(child, "checked", false);
        });
        this.$set(item, "checked", true);
      } else {
        // 多选题逻辑：多选切换
        this.$set(item, "checked", !item.checked);
      }

      // 强制触发 Vue 视图重绘，确保勾选选中样式 0 延迟秒级回显
      this.$forceUpdate();
    },

    /**
     * 上一题点击事件处理函数
     * @returns {void}
     */
    handlePrev() {
      if (this.index > 0) {
        this.index--;
        this.updateProgress();
      }
    },

    /**
     * 底部主按钮点击处理函数
     * 双阶段设计：
     * 1. 答案未确认前，按钮为“确认”。点击进行未选择拦截或答案校验输出（展示对错卡片与锁定选项），按钮变为“下一题”；
     * 2. 答案已确认后，按钮为“下一题”或“交卷”。点击顺畅进入下一题或发起交卷。
     * @returns {void}
     */
    handleNext() {
      const currentQuestion = this.listData[this.index];
      if (!currentQuestion) return;

      // 阶段一：答案未确认（按钮文案为“确认”）
      if (!currentQuestion.answered) {
        const hasSelected = (currentQuestion.children || []).some((child) => child.checked);
        if (!hasSelected) {
          this.$message.warning("请选择一个选项后再点击确认");
          return;
        }
        // 执行答案正确/错误比对校验，锁定当前题选项，显示答题反馈卡片
        this.checkCurrentQuestionAnswer(currentQuestion);
        return;
      }

      // 阶段二：答案已确认（按钮文案为“下一题”或“交卷”）
      if (this.index === this.listData.length - 1) {
        this.handleSubmit(true);
      } else {
        this.index++;
        this.updateProgress();
      }
    },

    /**
     * 查看答题情况模式下的“下一题”点击事件处理函数（无需答案校验与拦截）
     * @returns {void}
     */
    handleNextView() {
      if (this.index < this.listData.length - 1) {
        this.index++;
        this.updateProgress();
      }
    },

    /**
     * 提交试卷/交卷操作
     * @param {boolean} isVad - 是否需要校验所有题目已作答（用户主动点击交卷为 true，倒计时结束自动交卷为 false）
     * @returns {Promise<void>}
     */
    async handleSubmit(isVad) {
      // 若属于 431 状态（暂无题目）、无试卷 ID 或无试卷题目，直接返回，禁止执行交卷
      if (this.isCode431 || !this.id || !this.listData || !this.listData.length) {
        return;
      }

      // 检查是否所有题目都已作答
      const unanswered = this.listData.findIndex((question) => {
        return !question.children.some((child) => child.checked);
      });

      if (isVad && unanswered !== -1) {
        this.$message.warning(
          `第${unanswered + 1}题还未作答，请完成所有题目后再交卷`
        );
        return;
      }

      let questions = [];
      // 计算得分
      this.listData.forEach((question) => {
        const selectedAnswers = question.children.filter(
          (child) => child.checked
        );
        questions.push({
          id: question.id,
          answer: selectedAnswers.map((item) => item.key).join(""),
        });
      });

      if (this.disabled) return;
      this.disabled = true;
      try {
        const res = await examCommit({
          id: this.id,
          questions,
        });

        // 清除定时器及目标截止时间
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        this.targetEndTime = 0;

        // 提交成功，跳转至考试结果页
        if (res && (res.code == 200 || res.code == 0 || res.success) && res.data) {
          this.isSubmitted = true;
          this.navigateToResult({
            useTime: res.data.useTime,
            state: res.data.state,
            totalScore: res.data.totalScore,
            score: res.data.score,
          });
          return;
        }

        // 考试状态有误或已在后台结算交卷（code 为 431），直接跳转至分数结果页面，由结果页自动补全拉取成绩
        if (res && res.code == 431) {
          this.isSubmitted = true;
          this.navigateToResult();
          return;
        }
      } catch (error) {
        // 清除定时器及目标截止时间
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        this.targetEndTime = 0;

        // 捕获到 431 状态时，直接跳转至分数结果页面
        if (
          error &&
          (error.code == 431 ||
            (error.response && error.response.status == 431) ||
            (error.response && error.response.data && error.response.data.code == 431))
        ) {
          this.isSubmitted = true;
          this.navigateToResult();
        } else {
          this.$message.error("提交失败，请重试");
        }
      } finally {
        setTimeout(() => {
          this.disabled = false;
        }, 2000);
      }
    },
    /**
     * 发起 API 请求，获取答题情况详情数据，并预计算题目及选项的正确性与对错高亮 Class
     * @returns {void}
     */
    getSituation() {
      if (!this.situationId) return;

      examSituation({
        id: this.situationId,
      }).then((res) => {
        if (res && (res.code == 200 || res.code == 0)) {
          (res.data.results || []).forEach((item) => {
            // 提取学员选择选项 Key 与标准正确答案 Key
            const userAnswers = (item.answer ? String(item.answer).replace(/[,，\s]/g, "") : "")
              .toUpperCase()
              .split("")
              .filter(Boolean);
            const realAnswers = (item.realAnswer || item.rightAnswer ? String(item.realAnswer || item.rightAnswer).replace(/[,，\s]/g, "") : "")
              .toUpperCase()
              .split("")
              .filter(Boolean);

            const userAnswerStr = userAnswers.length > 0 ? userAnswers.join("、") : "未作答";
            const realAnswerStr = realAnswers.length > 0 ? realAnswers.join("、") : "无";
            const isCorrect = item.state == 1;

            this.$set(item, "userAnswerStr", userAnswerStr);
            this.$set(item, "realAnswerStr", realAnswerStr);
            this.$set(item, "isCorrect", isCorrect);
            this.$set(item, "answered", true);

            // 预先给每个选项绑定解析后的 Class 与标志
            item.children = Object.entries(item.titleOptionJson || {}).map(([k, v]) => {
              const keyUpper = k.toUpperCase();
              const isUserChecked = userAnswers.includes(keyUpper);
              const isAns = realAnswers.includes(keyUpper);

              let statusClass = "";
              let checkClass = "";
              let textClass = "";

              if (isUserChecked) {
                statusClass = isAns ? "is-correct-target" : "is-wrong-target";
                checkClass = isAns ? "correct-check-box" : "wrong-check-box";
                textClass = isAns ? "correct-text" : "wrong-text";
              } else {
                statusClass = isAns ? "is-miss-target" : "";
                checkClass = isAns ? "miss-check-box" : "";
                textClass = isAns ? "miss-text" : "";
              }

              return {
                key: k,
                content: v,
                checked: isUserChecked,
                isAnswer: isAns,
                statusClass,
                checkClass,
                textClass,
              };
            });
          });

          this.listData = res.data.results || [];
          this.infoData = res.data || {};

          // 如果有 situationIndex 参数，直接跳转到指定题目
          if (this.situationIndex) {
            const targetIndex = parseInt(this.situationIndex) - 1;
            if (targetIndex >= 0 && targetIndex < this.listData.length) {
              this.index = targetIndex;
              this.updateProgress();
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 1400px;
  margin: 0 auto;
  box-sizing: border-box;
  padding-left: 6px;
  box-sizing: border-box;
  padding-top: 30px;
  min-height: 400px;
  display: flex;
  flex-wrap: wrap;
  .contentBox {
    width: 100%;
    padding: 30px 50px;
    height: 183px;
    margin-bottom: 30px;
    box-sizing: border-box;
    background: #fff;

    .line {
      width: 1300px;
      height: 16px;
      background: rgba(0, 216, 195, 0.12);
      border-radius: 8px;
      margin-top: 8px;
      div {
        transition: all 0.3 linear;
        border-radius: 8px;
        background: #00d8c3;
        height: 100%;
      }
    }
  }
  .contentBoxTitle {
    font-size: 26px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 25px;
  }

  .contentBoxContent {
    .contentHeader {
      display: flex;
      align-items: center;
      .left {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #829199;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        margin-right: 78px;
        .leftNoProgress {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #00161a;
          line-height: 22px;
          font-style: normal;
        }
        .leftProgress {
          margin: 0 4px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 26px;
          color: #00161a;
          line-height: 37px;
          text-align: left;
          font-style: normal;
        }
      }
      .right {
        img {
          width: 20px;
          height: 20px;
          vertical-align: text-top;
        }
        .rightText {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #829199;
          line-height: 22px;
          text-align: left;
          font-style: normal;
          margin: 0 4px;
        }
        .rightTime {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 26px;
          color: #00161a;
          line-height: 37px;
          text-align: left;
          font-style: normal;
        }
      }
    }
  }
}

.contentList {
  width: 100%;
  background: #fff;
  min-height: 490px;
  padding: 40px 50px;
  box-sizing: border-box;
  margin-bottom: 30px;
  .contentListFooter {
    display: flex;
    align-items: center;
    margin-top: 60px;
    div {
      width: 200px;
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      border-radius: 4px;
      cursor: pointer;
    }
    .pre {
      background: #ffffff;
      border: 1px solid #00d8c3;
      color: #00d8c3;
      margin-right: 15px;
    }

    .next {
      background: #00d8c3;
      color: #ffffff;
      transition: opacity 0.2s;
      &.is-disabled {
        opacity: 0.65;
      }
    }
  }

  .contentListTitle {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #00161a;
    line-height: 28px;
    text-align: left;
    font-style: normal;
  }
  .contentListType {
    width: 68px;
    height: 26px;
    background: #00d8c3;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 8px 0 35px;
  }

  .contentListBox {
    margin-top: 35px;
    .contentListBoxItem {
      cursor: pointer;
      display: flex;
      align-content: center;
      margin-bottom: 20px;
      .contentListBoxItemText {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #2c3041;
        font-style: normal;
        border: none !important;
      }
      .contentListBoxItemCheck {
        width: 22px;
        height: 22px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #b8c5cc;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 14px;
          height: 14px;
        }

        .green-check {
          color: #00d8c3;
          font-size: 15px;
          font-weight: bold;
          line-height: 1;
        }

        .red-cross {
          color: #ff4d4f;
          font-size: 15px;
          font-weight: bold;
          line-height: 1;
        }

        .miss-green-check {
          color: #008f81;
          font-size: 13px;
          opacity: 0.7;
          line-height: 1;
        }
      }

      .active {
        border: 1px solid #00d8c3;
        color: #00d8c3;
      }

      /* 统一贴合项目主色调的学员选对选项样式 (青绿 #00d8c3) */
      &.is-correct-target {
        .correct-check-box {
          border: 1px solid #00d8c3 !important;
          background-color: rgba(0, 216, 195, 0.15) !important;
        }
        .correct-text {
          color: #00d8c3 !important;
          font-weight: 600;
        }
      }

      /* 正确答案但学员漏选的样式 (虚线绿框提示) */
      &.is-miss-target {
        .miss-check-box {
          border: 1px dashed #00d8c3 !important;
          background-color: rgba(0, 216, 195, 0.05) !important;
        }
        .miss-text {
          color: #008f81 !important;
          font-weight: 500;
        }
      }

      /* 符合项目 UI 规范的错误选项样式 (柔和暖红 #FF4D4F) */
      &.is-wrong-target {
        .wrong-check-box {
          border: 1px solid #ff4d4f !important;
          background-color: #fff2f0 !important;
        }
        .wrong-text {
          color: #ff4d4f !important;
          font-weight: 400;
        }
      }
    }
  }

  /* 多选题选完答案后的专属确认按钮样式 */
  .multi-confirm-btn-wrap {
    margin-top: 15px;
    display: flex;
    justify-content: flex-start;
    .multi-confirm-btn {
      width: 120px;
      height: 38px;
      background: #00d8c3;
      color: #ffffff;
      font-size: 15px;
      font-weight: 500;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: opacity 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
  }

  /* 答题即时反馈卡片提示栏 */
  .instant-feedback-bar {
    margin-top: 24px;
    padding: 14px 20px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 15px;
    font-weight: 500;
    box-sizing: border-box;

    .feedback-status-icon {
      font-size: 20px;
    }

    .feedback-msg-text {
      line-height: 22px;
    }

    /* 回答正确：符合项目的青绿风格卡片 */
    &.feedback-correct {
      background: rgba(0, 216, 195, 0.08);
      border: 1px solid rgba(0, 216, 195, 0.25);
      color: #00a393;
      .feedback-status-icon {
        color: #00d8c3;
      }
    }

    /* 回答错误：高级柔和暖红卡片 */
    &.feedback-wrong {
      background: #fff2f0;
      border: 1px solid #ffccc7;
      color: #ff4d4f;
      .feedback-status-icon {
        color: #ff4d4f;
      }
      .highlight-ans {
        font-weight: 600;
        color: #ff4d4f;
        margin-left: 6px;
        font-size: 16px;
      }
    }
  }
}
</style>
